import { useState } from 'react'
import { useSnapshot } from '../state/TelephonyProvider'
import { useCommand } from '../state/useCommand'
import { useDial } from '../state/useDial'
import { displayName, isDnd } from '../state/roster'
import { TelephonyCommandNames } from '../contract'
import { BLF, tileBackground, contrastingColor } from './blf'
import { SupervisorDialog } from './SupervisorDialog'
import { IconDotsVertical } from '../ui/icons'

export function ExtensionsPanel() {
  const { extensions } = useSnapshot()
  const run = useCommand()
  const dial = useDial()
  const [supTarget, setSupTarget] = useState<string | null>(null)

  return (
    <div className="sb-panel">
      {extensions.length === 0 ? (
        <div className="sb-panel-empty">Waiting for BLF state…</div>
      ) : (
        <div className="blf-grid">
          {extensions.map((x) => {
            const dnd = isDnd(x.ext)
            const bg = tileBackground(x.state, dnd)
            const ringing = x.state === 'ringing'
            const busy = x.state === 'in_use' || x.state === 'busy' || x.state === 'on_hold'
            const style = { position: 'relative' as const, ...(bg ? { background: bg, color: contrastingColor(bg) } : {}) }
            const cls = `blf-tile${bg ? ' blf-colored' : ''}${ringing ? ' blf-ringing' : ''}`
            const onTile = () => {
              if (ringing) {
                void run(
                  { command: TelephonyCommandNames.Pickup, params: { extension: x.ext } },
                  { successMessage: `Picked up ${displayName(x.ext)}` }
                )
              } else {
                dial(x.ext)
              }
            }
            return (
              <div
                key={x.ext} className={cls} style={style}
                title={ringing ? `Pick up ${x.ext}` : `Dial ${x.ext}`}
                role="button" tabIndex={0}
                onClick={onTile}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onTile() } }}
              >
                <div className="blf-ext">{x.ext}</div>
                <div className="blf-name">{displayName(x.ext)}</div>
                {busy ? (
                  <button
                    className="sb-iconbtn" aria-label={`Supervise ${x.ext}`} title="Supervise"
                    style={{ position: 'absolute', top: 2, right: 2, color: 'inherit', opacity: 0.85 }}
                    onClick={(e) => { e.stopPropagation(); setSupTarget(x.ext) }}
                  >
                    <IconDotsVertical size={14} stroke={1.9} />
                  </button>
                ) : null}
              </div>
            )
          })}
        </div>
      )}
      <div className="legend">
        <span><span className="blf-swatch" style={{ background: BLF.inUse }} /> in use</span>
        <span><span className="blf-swatch" style={{ background: BLF.onHold }} /> on hold</span>
        <span><span className="blf-swatch" style={{ background: BLF.dnd }} /> DND</span>
        <span><span className="blf-swatch" style={{ background: BLF.offline }} /> offline</span>
        <span><span className="blf-swatch blf-swatch-theme" /> idle</span>
        <span><span className="blf-swatch blf-swatch-ring" /> ringing</span>
      </div>
      {supTarget ? <SupervisorDialog target={supTarget} onClose={() => setSupTarget(null)} /> : null}
    </div>
  )
}
